__turbopack_context__.v({
  "cellContainer": "CellContainer-module__9cdmHa__cellContainer",
  "cellContainerActions": "CellContainer-module__9cdmHa__cellContainerActions",
  "cellContainerHeader": "CellContainer-module__9cdmHa__cellContainerHeader",
});
